import { useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { Match } from 'src/shared/schemas/partner-match'

export const getMatchById = async (matchId: number) => {
  const result = await getRequest<{ match: Match | null }>(`/partner-matches/${matchId}`)
  if (!result) return null
  return result.match
}

export const useMatchById = (matchId: number | null, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: queries.partnerMatch.detail(matchId || -1).queryKey,
    queryFn: () => getMatchById(matchId || -1),
    staleTime: 1000 * 60 * 60, // 1 hour
    enabled: options?.enabled && matchId !== null,
  })
}
